
import React from 'react';
import { AppView } from '../types';

interface DebugViewIndicatorProps {
  currentView: AppView;
  hoveredElement?: string | null; // New prop
}

interface ViewDetails {
  displayName: string;
  fileName: string;
}

const DebugViewIndicator: React.FC<DebugViewIndicatorProps> = ({ currentView, hoveredElement }) => {
  const viewDetailsMap: Record<AppView, ViewDetails> = {
    landing: { displayName: "Landing Page", fileName: "LandingPage.tsx" },
    studio: { displayName: "Image Studio", fileName: "App.tsx (Main Layout)" },
    store: { displayName: "Store Page", fileName: "StorePage.tsx" },
    profile: { displayName: "User Profile", fileName: "UserProfilePage.tsx" }
  };

  const details = viewDetailsMap[currentView] || { displayName: currentView, fileName: "Unknown.tsx" };

  const title = `Current View: ${details.displayName} (${details.fileName})${hoveredElement ? ` | Hovering: ${hoveredElement}` : ''}`;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '10px',
        left: '10px',
        padding: '6px 12px',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        color: 'white',
        fontSize: '12px',
        borderRadius: '4px',
        zIndex: 9999, 
        boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
        fontFamily: 'monospace',
        maxWidth: 'calc(100vw - 20px)', 
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        border: '1px solid rgba(255,255,255,0.2)'
      }}
      aria-live="polite"
      role="status"
      title={title}
    >
      Debug: <span style={{ fontWeight: 'bold', color: '#60A5FA' }}>{details.displayName}</span>
      {/* <span style={{ color: '#9CA3AF', marginLeft: '5px' }}>({details.fileName})</span> */}
      {hoveredElement && (
        <>
          <span style={{ margin: '0 5px', color: '#4B5563' }}>|</span>
          <span style={{ color: '#FBBF24' }}>Hover:</span>
          <span style={{ marginLeft: '4px', color: '#D1D5DB' }}>{hoveredElement}</span>
        </>
      )}
    </div>
  );
};

export default DebugViewIndicator;
